export default "__VITE_ASSET__B0BY8uJI__"